<template>
  <VRow class="candidate-wrapper">
    <VCol cols="12" md="6" class="px-5 pb-6 px-md-12 pr-md-10 pt-10">
      <CandidateHeader :company="company" :candidate="candidate" :vacancy="vacancy" />
      <CandidateInterviewResolver
        ref="interviewResolver"
        :vacancy="vacancy"
        :candidate="candidate"
        :are-questions-equal="areQuestionsEqual"
        @online-interview-played="onlineInterviewPlayed"
      />
    </VCol>
    <VCol cols="12" md="6" class="py-0 pa-md-0">
      <VCard
        outlined
        flat
        tile
        class="right-panel pa-md-0 fill-height light-background"
      >
        <CandidateTabsPanel
          v-model="activeTab"
          :vacancy="vacancy"
          :candidate="candidate"
          :show-questions-tab="showQuestionsTab"
          :question="activeQuestion"
          :are-questions-equal="areQuestionsEqual"
          @updated:question="activeQuestion = $event"
          @show-interview="changeShowOfficeInterview($event)"
        />
      </VCard>
    </VCol>
  </VRow>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  computed, toRefs,
} from '@vue/composition-api';
import CandidateInterviewResolver from './CandidateInterviewResolver.vue';
import CandidateHeader from './CandidateHeader.vue';
import CandidateTabsPanel from './CandidateTabsPanel.vue';
import { interviewStatuses, interviewType } from '../../enums';
import ApiMixin from '../../mixins/ApiMixin';

export default {
  name: 'Candidate',
  components: {
    CandidateTabsPanel,
    CandidateInterviewResolver,
    CandidateHeader,
  },
  mixins: [ApiMixin],
  props: {
    company: {
      type: Object,
      required: true,
    },
    vacancy: {
      type: Object,
      required: true,
    },
    candidate: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { vacancy, candidate } = toRefs(props);

    const areQuestionsEqual = computed(() => {
      const vacancyQuestionIds = new Set((vacancy.value?.script?.questions || []).map(q => q.id));
      const candidateQuestionIds = new Set(candidate.value?.interview?.timestamps.map(q => q.questionId));

      if (!vacancyQuestionIds.size || !candidateQuestionIds.size) {
        return true;
      }

      if (candidateQuestionIds.size !== vacancyQuestionIds.size) return false;
      for (const id of vacancyQuestionIds) {
        if (!candidateQuestionIds.has(id)) return false;
      }
      return true;
    });


    return {
      areQuestionsEqual,
    };
  },
  computed: {
    ...mapGetters('candidatePage', ['activeInterviewType']),
    activeTab: {
      get() {
        return this.$store.state.candidatePage.activeTab;
      },
      set(value) {
        this.$store.commit('candidatePage/setActiveTab', value);
      },
    },
    activeQuestion: {
      get() {
        return this.$store.state.candidatePage.activeQuestion;
      },
      set(value) {
        this.$store.commit('candidatePage/setActiveQuestion', value);
      },
    },
    showQuestionsTab() {
      return this.candidate.interview?.status === interviewStatuses.READY
        && this.activeInterviewType === interviewType.ONLINE_INTERVIEW && !this.expanded;
    },
  },
  methods: {
    onlineInterviewPlayed() {
      this.activeTab = 1;
    },
    changeShowOfficeInterview(newId) {
      this.$refs.interviewResolver.changeShowOfficeInterview(newId);
    },
  },
};
</script>

<style lang="scss">
@media #{map-get($display-breakpoints, 'md-and-up')} {
  .candidate-wrapper {
    height: 100%;

    .candidate-tabs-panel__tabs {
      padding-top: 26px !important;
    }

    .v-card {
      border-right: 0 !important;
    }

    .candidate-tabs-panel {
      display: flex;
      flex-grow: 1;
      background-color: #f5f5f5;

      .v-window {
        background-color: #f5f5f5;
      }
    }

    .candidate-log {
      background-color: #f5f5f5;
    }

    .messages-container {
      padding-right: 0 !important;
    }
  }
}
</style>
